import queryString from 'query-string';
import { Url } from '@wix/da-url';
var GIVE_BADGE_POPUP_URL = Url.nonEclipseLink('modal/badge/give');
var GIVE_POINTS_POPUP_URL = Url.nonEclipseLink('account/points/give');
var DONATE_POINTS_POPUP_URL = Url.nonEclipseLink('account/points/donate');
export var makeBadgeIframeSrc = function (badgeName, userId) {
    var referrer = '';
    if (typeof window !== 'undefined') {
        referrer = window.location.toString();
    }
    return GIVE_BADGE_POPUP_URL + "?" + queryString.stringify({
        badgetype: badgeName,
        to_user: userId,
        trade_id: 0,
        referrer: referrer,
    });
};
export var makePointsIframeSrc = function (username) {
    return GIVE_POINTS_POPUP_URL + "?" + queryString.stringify({
        to_user: username,
    });
};
export var makeDonatePointsIframeSrc = function (username, moduleId) {
    return DONATE_POINTS_POPUP_URL + "?" + queryString.stringify({
        to_user: username,
        for_donation: moduleId,
    });
};
export var makeMyGroupsIframeSrc = function (username) {
    return Url.nonEclipseLink(username + "/modals/mygroups/");
};
//# sourceMappingURL=helpers.js.map